import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export const share = () => {

	let el = document.querySelector('[data-animation="share"]')

	if (!el || window.innerWidth < 960) return false

	ScrollTrigger.create({
		trigger: el,
		start: 'top 25%',
		end: 'bottom 75%',
		pin: el,
		endTrigger: el.parentElement,
		// markers: true,
	})

}

export default () => { }